import { RegisterForm } from '@/components/auth/RegisterForm';
import { FunctionComponent } from 'react';

const RegisterPage: FunctionComponent = () => {
  return (
    <div className='bg-slate-50 dark:bg-stone-950 flex min-h-svh flex-col items-center justify-center p-6 md:p-10'>
      <div className='w-full max-w-sm md:max-w-3xl'>
        <RegisterForm />
      </div>
    </div>
  );
};

export default RegisterPage;
